<template>
    <div class="societiesCarouselMobile">
        <Carousel :items-to-show="1.2">
            <Slide v-for="src in linksList" :key="src">
                <videoPlayer :src="src" />
            </Slide>

            <template #addons>
                <Navigation />
            </template>
        </Carousel>
    </div>
</template>

<script src="./script.js"></script>
